require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-honduras-remote-area-rural-electrification-program.json") })
        }
      }, "path---en-us-project-honduras-remote-area-rural-electrification-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-honduras-remote-area-rural-electrification-program!./.cache/json/en-us-project-honduras-remote-area-rural-electrification-program.json
// module id = 515
// module chunks = 231608221292675